<template>
  <div class="CloudServices">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/paascustomizedVideo.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">全球聚合高性能云服务</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">简化企业云服务运维工作，提供行业领先的硬件计算能力，可弹性扩展<br>资源用量</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'CloudServices',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
